import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import App from './App';
import AppDevicesPreview from './AppDevicesPreview';
import General from './utils/General';

ReactDOM.render(
    (
      General.loadAppInIframe() ?
      <AppDevicesPreview />
      :
      <BrowserRouter>
        <App />
      </BrowserRouter>
    ),
    document.getElementById("root")
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
